import { Zap, Users, Wrench, Clock } from 'lucide-react';

const stats = [
  { icon: Users, value: '500+', label: 'Happy Customers' },
  { icon: Wrench, value: '1000+', label: 'Jobs Completed' },
  { icon: Clock, value: '12hrs', label: 'Daily Availability' },
  { icon: Zap, value: '7', label: 'Days a Week' },
];

export const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src="https://images.pexels.com/photos/9679179/pexels-photo-9679179.jpeg"
                alt="Fred Joules Electricians team member working on an electrical panel"
                className="w-full h-full object-cover"
                data-testid="about-image"
              />
            </div>
            {/* Stats overlay */}
            <div className="absolute -bottom-8 -right-4 lg:-right-8 bg-yellow-400 p-6 max-w-xs">
              <span className="text-4xl font-bold text-black block">7 Days</span>
              <span className="text-black/70 font-medium">a Week, 8AM - 8PM</span>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="overline" data-testid="about-overline">About Us</span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-3 tracking-tight mb-6" data-testid="about-heading">
              Your Neighborhood<br />Electrical Experts
            </h2>
            <div className="space-y-4 text-zinc-300 text-lg leading-relaxed">
              <p data-testid="about-paragraph-1">
                Located right off Canyon Road, Fred Joules Electricians provides the Portland and Beaverton communities with top-tier electrical troubleshooting, repairs, and installations.
              </p>
              <p data-testid="about-paragraph-2">
                We know electrical issues don't just happen during standard business hours, which is why our team is available <span className="text-yellow-400 font-semibold">7 days a week from 8 AM to 8 PM</span> to keep your home safe and fully powered.
              </p>
              <p data-testid="about-paragraph-3">
                Whether you're dealing with a sudden power outage, need to upgrade your electrical panel, or want to install new lighting fixtures, our licensed experts bring decades of combined experience to every job.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10 pt-10 border-t border-white/10">
              {stats.map((stat, index) => {
                const Icon = stat.icon;
                return (
                  <div key={stat.label} className="text-center" data-testid={`about-stat-${index}`}>
                    <Icon className="w-6 h-6 text-yellow-400 mx-auto mb-2" aria-hidden="true" />
                    <span className="text-2xl font-bold text-white block">{stat.value}</span>
                    <span className="text-xs text-zinc-500 uppercase tracking-wider">{stat.label}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
